// @ts-nocheck
import Vue from 'vue'
import VueRouter from 'vue-router'
import limitRouters from './limit.js'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

import Layout from '@/layout'

// * 公共路由
const constantRoutes = [{
  path: '/',
  name: 'Home',
  component: Layout,
  redirect: '/index',
  children: [{
    path: '/index',
    name: 'index',
    meta: process.env.VUE_APP_NAME,
    component: Home,
  },  {
    path: '/training',
    name: 'training',
    meta: '培训中心',
    component: () => import('@/views/trainingCenter/index.vue')
  }, {
    path: '/training/details',
    name: 'trainingDetails',
    meta: '培训中心',
    component: () => import('@/views/trainingCenter/examination.vue')
  } ]
}]

//! 错误路由集 404页面必须放在最后
const errorRoutes = [{
  path: '*',
  redirect: '/404'
}]


// 限制路由注入
// const allRoutes = constantRoutes.concat(limitRouters);
// 此处加入去重处理
const allRoutes = [...new Set([...constantRoutes, ...limitRouters, ...errorRoutes])];

// The base option is now passed as the first argument to createWebHistory (and other histories):
const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // 跳转或返回缓存页保证位置置顶
  scrollBehavior: () => ({
    y: 0
  }),
  routes: allRoutes
})

const router = createRouter()

export default router